/* ============================================================
   cs-picks.js · canvArt studios
   Steuert den "Passt dazu"-Block auf Produktseite und im Cart Drawer.

   - Event-Delegation auf document → überlebt jedes Neu-Rendern des Drawers
   - Läuft genau einmal, auch wenn das Snippet mehrfach eingebunden wird
   - Größen-/Varianten-Match: übernimmt die aktuell gewählte Auswahl,
     fällt sauber auf die Standardvariante zurück
   ============================================================ */
(function () {
  'use strict';

  if (window.__csPicksInit) return;
  window.__csPicksInit = true;

  var CART_SECTIONS = 'cart-drawer,cart-icon-bubble';

  /* ---------- Helpers ---------- */

  function parseVariants(btn) {
    try {
      return JSON.parse(btn.getAttribute('data-cs-variants') || '[]');
    } catch (e) {
      return [];
    }
  }

  /**
   * Wählt die Variante, die zur aktuellen Auswahl passt.
   * 1. exakter Treffer über alle Optionswerte
   * 2. Treffer nur über die letzte Option (in der Regel die Größe)
   * 3. erste verfügbare Variante
   * 4. Fallback-ID aus dem Markup
   */
  function pickVariant(btn, refOpts) {
    var variants = parseVariants(btn);
    var fallback = parseInt(btn.getAttribute('data-cs-fallback'), 10) || null;
    if (!variants.length) return fallback;

    if (refOpts) {
      var exact = variants.filter(function (v) {
        return v.a && v.o === refOpts;
      })[0];
      if (exact) return exact.id;

      var parts = refOpts.split('|');
      var size = parts[parts.length - 1];
      if (size) {
        var bySize = variants.filter(function (v) {
          var vp = v.o.split('|');
          return v.a && vp[vp.length - 1] === size;
        })[0];
        if (bySize) return bySize.id;
      }
    }

    var firstAvailable = variants.filter(function (v) {
      return v.a;
    })[0];
    return firstAvailable ? firstAvailable.id : fallback;
  }

  /** "€57,95" — entspricht der Geldformatierung des Shops. */
  function fmt(cents) {
    return String.fromCharCode(8364) + (cents / 100).toFixed(2).replace('.', ',');
  }

  /**
   * Schreibt in jede Empfehlungszeile den Preis der Variante, die beim Klick
   * auf "Hinzufügen" tatsächlich in den Warenkorb geht. Anzeige und Klick verwenden
   * dieselbe Variantenauswahl einschließlich des Fallbacks.
   */
  function updatePickPrices(root) {
    var scope = root || document;

    /* querySelectorAll durchsucht nur die Nachkommen. Wird der Empfehlungs-
       block selbst übergeben, findet es ihn also NICHT — deshalb muss er
       hier explizit mit aufgenommen werden. */
    var boxes = [];
    if (scope.nodeType === 1 && scope.hasAttribute && scope.hasAttribute('data-cs-picks')) {
      boxes.push(scope);
    }
    Array.prototype.push.apply(boxes, scope.querySelectorAll('[data-cs-picks]'));

    boxes.forEach(function (box) {
      var refOpts = box.getAttribute('data-cs-ref-opts') || '';
      Array.prototype.forEach.call(box.querySelectorAll('[data-cs-add]'), function (btn) {
        var item = btn.closest('.cs-picks__item');
        if (!item) return;
        var priceEl = item.querySelector('[data-cs-price]');
        var optEl = item.querySelector('[data-cs-opt]');
        if (!priceEl) return;

        var selectedId = pickVariant(btn, refOpts);
        var hit = parseVariants(btn).filter(function (v) { return v.id === selectedId; })[0];
        if (hit) {
          priceEl.textContent = fmt(hit.p);
          if (optEl) {
            optEl.textContent = hit.o.split('|').join(' · ');
            optEl.hidden = false;
          }
        } else {
          btn.disabled = true;
        }
      });
    });
  }

  /** Aktuell im Produktformular gewählte Variante (nur Produktseite). */
  function currentProductVariantId() {
    var form = document.querySelector(
      'form[action*="/cart/add"]:not([hidden]) [name="id"], product-form form [name="id"]'
    );
    if (!form) return null;
    var val = parseInt(form.value, 10);
    return isNaN(val) ? null : val;
  }

  function showError(root, message) {
    var el = root && root.querySelector('[data-cs-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function clearError(root) {
    var el = root && root.querySelector('[data-cs-error]');
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
  }

  /** Antwort der Cart-API in den Drawer schreiben und ihn öffnen. */
  /**
   * Dawn setzt bei leerem Warenkorb die Klasse is-empty auf <cart-drawer>,
   * <cart-drawer-items> und .drawer__inner. Beim Nachladen wird nur der
   * Inhalt ersetzt — die Klasse am äußeren Element bleibt stehen. Folge:
   * Kopfzeile ausgeblendet, Inhaltsbereich als zentriertes Grid, der
   * Warenkorb wirkt leer. Betrifft nur den ersten Artikel.
   */
  function clearEmptyState(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-empty');
    var marked = drawer.querySelectorAll('.is-empty');
    Array.prototype.forEach.call(marked, function (el) {
      el.classList.remove('is-empty');
    });
  }

  function applyCartResponse(data) {
    var drawer = document.querySelector('cart-drawer');
    clearEmptyState(drawer);

    if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
      drawer.renderContents(data);
      setTimeout(function () {
        clearEmptyState(drawer);
        document.dispatchEvent(new CustomEvent('cs:cart-updated'));
      }, 0);
      return;
    }

    // Fallback, falls das Theme-Skript sich ändert
    if (data && data.sections && data.sections['cart-drawer']) {
      var parsed = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
      var fresh = parsed.querySelector('#CartDrawer');
      var live = document.querySelector('#CartDrawer');
      if (fresh && live) live.innerHTML = fresh.innerHTML;
    }
    if (data && data.sections && data.sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var pb = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
        var freshBubble = pb.querySelector('#shopify-section-cart-icon-bubble') || pb.body;
        bubble.innerHTML = freshBubble.innerHTML;
      }
    }
    if (drawer) {
      clearEmptyState(drawer);
      if (typeof drawer.open === 'function') drawer.open();
    }
  }

  function addItems(items, root, onDone) {
    clearError(root);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: CART_SECTIONS })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          return { ok: res.ok, body: body };
        });
      })
      .then(function (r) {
        if (!r.ok) {
          showError(root, r.body && r.body.description ? r.body.description : 'Das hat leider nicht geklappt. Bitte lade die Seite neu.');
          if (onDone) onDone(false);
          return;
        }
        applyCartResponse(r.body);
        if (onDone) onDone(true);
      })
      .catch(function () {
        showError(root, 'Verbindungsfehler. Bitte versuch es noch einmal.');
        if (onDone) onDone(false);
      });
  }

  /* ---------- Delegierte Klicks ---------- */

  document.addEventListener('click', function (event) {
    /* Einzelnes Motiv hinzufügen */
    var addBtn = event.target.closest('[data-cs-add]');
    if (addBtn) {
      event.preventDefault();
      if (addBtn.classList.contains('is-loading') || addBtn.disabled) return;

      var root = addBtn.closest('[data-cs-picks]');
      var refOpts = root ? root.getAttribute('data-cs-ref-opts') || '' : '';
      var variantId = pickVariant(addBtn, refOpts);

      if (!variantId) {
        showError(root, 'Dieses Motiv ist gerade nicht verfügbar.');
        return;
      }

      addBtn.classList.add('is-loading');
      addItems([{ id: variantId, quantity: 1 }], root, function (ok) {
        addBtn.classList.remove('is-loading');
        if (ok) {
          addBtn.classList.add('is-done');
          addBtn.disabled = true;
        }
      });
      return;
    }

    /* Komplettes Set hinzufügen (nur Produktseite) */
    var setBtn = event.target.closest('[data-cs-set]');
    if (setBtn) {
      event.preventDefault();
      if (setBtn.classList.contains('is-loading') || setBtn.disabled) return;

      var setRoot = setBtn.closest('[data-cs-picks]');
      if (!setRoot) return;

      var setRefOpts = setRoot.getAttribute('data-cs-ref-opts') || '';
      var items = [];

      var mainVariant = currentProductVariantId();
      if (mainVariant) items.push({ id: mainVariant, quantity: 1 });

      Array.prototype.forEach.call(setRoot.querySelectorAll('[data-cs-add]'), function (b) {
        if (b.classList.contains('is-done')) return;
        var vid = pickVariant(b, setRefOpts);
        if (vid) items.push({ id: vid, quantity: 1 });
      });

      if (!items.length) {
        showError(setRoot, 'Es ist gerade nichts auswählbar.');
        return;
      }

      setBtn.classList.add('is-loading');
      addItems(items, setRoot, function (ok) {
        setBtn.classList.remove('is-loading');
        if (ok) {
          Array.prototype.forEach.call(setRoot.querySelectorAll('[data-cs-add]'), function (b) {
            b.classList.add('is-done');
            b.disabled = true;
          });
        }
      });
    }
  });

  /* ---------- Auswahl auf der Produktseite mitführen ---------- */

  /* Die Optionswerte werden bewusst NICHT über die Custom-Elements
     <variant-selects>/<variant-radios> gelesen — der Picker dieses Shops ist
     ein angepasstes Snippet und nutzt diese Hüllen nicht. Stattdessen werden
     die Optionsgruppen über Dawns Klasse .product-form__input gefunden, die
     unabhängig vom Picker-Typ gesetzt ist. */

  var OPTION_GROUPS = [
    '.product-form__input--pill',
    '.product-form__input--dropdown',
    '.product-form__input--swatch',
    'variant-selects fieldset',
    'variant-radios fieldset'
  ].join(',');

  function readSelectedOptions() {
    var values = [];
    var seen = [];
    var groups = document.querySelectorAll(OPTION_GROUPS);

    Array.prototype.forEach.call(groups, function (g) {
      if (seen.indexOf(g) !== -1) return;
      seen.push(g);

      var checked = g.querySelector('input[type="radio"]:checked');
      if (checked) {
        values.push((checked.value || '').trim());
        return;
      }
      var select = g.querySelector('select');
      if (select) values.push((select.value || '').trim());
    });

    /* Letzte Rettung: irgendein gecheckter Varianten-Radio auf der Seite */
    if (!values.length) {
      var loose = document.querySelectorAll('.product-form__input input[type="radio"]:checked');
      Array.prototype.forEach.call(loose, function (r) {
        values.push((r.value || '').trim());
      });
    }

    return values.filter(function (v) { return v !== ''; });
  }

  function syncRefOpts() {
    var root = document.querySelector('[data-cs-picks][data-cs-context="pdp"]');
    if (!root) return;

    var values = readSelectedOptions();
    if (values.length) root.setAttribute('data-cs-ref-opts', values.join('|'));
    updatePickPrices();
  }

  var syncTimer = null;
  function scheduleSync() {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(syncRefOpts, 60);
  }

  /* Jede Radio-/Select-Änderung auf der Seite anstoßen — der Abgleich ist
     billig, und so bleibt er unabhängig davon, wie der Picker aufgebaut ist. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.tagName) return;
    var tag = t.tagName.toLowerCase();
    if (tag === 'select' || (tag === 'input' && t.type === 'radio')) scheduleSync();
  });

  /* Manche Picker ersetzen ihr Markup beim Wechsel, ohne ein change-Event zu
     hinterlassen, das uns erreicht. Deshalb zusätzlich auf DOM-Austausch im
     Produktbereich reagieren. */
  function observePicker() {
    if (typeof MutationObserver !== 'function') return;
    var first = document.querySelector('.product-form__input');
    var target = first && first.parentNode ? first.parentNode : null;
    if (!target) return;
    new MutationObserver(scheduleSync).observe(target, { childList: true, subtree: true });
  }

  function init() {
    syncRefOpts();
    observePicker();
    /* Der Picker wird teils nach dem ersten Frame gerendert. */
    setTimeout(syncRefOpts, 300);
    setTimeout(syncRefOpts, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Cart Drawer: nach jedem Neu-Rendern die Preise nachziehen */
  document.addEventListener('cs:cart-updated', function () { updatePickPrices(); });
})();

